"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputCheckbox = exports.InputCheckbox = exports.InputCheckboxDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var field_container_1 = require("../elements/field-container");
var theme_1 = require("@shapeable/theme");
var field_container_2 = require("../elements/field-container");
var form_field_id_1 = require("../../utils/form-field-id");
var checkbox_1 = require("../elements/checkbox");
exports.InputCheckboxDefaultProps = {
  checked: false,
  name: 'checkbox',
  required: false,
  value: 'yes',
  valid: true,
  labelRenderer: field_container_2.defaultLabelRenderer,
  icon: 'TickIcon',
  onChange: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-self: flex-start;\n  "], ["\n    align-self: flex-start;\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Checkbox: (0, styled_components_1.default)(checkbox_1.Checkbox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles)
};
var InputCheckbox = function (props) {
  var className = props.className,
    field = props.field,
    icon = props.icon,
    onChange = props.onChange;
  var value = field.value,
    name = field.name,
    checkedValue = field.checkedValue,
    valid = field.valid;
  var handleChange = function (checked) {
    onChange({
      name: name,
      value: checked
    });
  };
  var checked = checkedValue ? value === checkedValue : !!value;
  return React.createElement(My.Container, {
    field: field,
    className: className
  }, React.createElement(My.Checkbox, {
    id: (0, form_field_id_1.formFieldId)(field),
    valid: field.valid,
    onChange: handleChange,
    checked: checked,
    value: value,
    size: 24
  }));
};
exports.InputCheckbox = InputCheckbox;
exports.InputCheckbox.defaultProps = exports.InputCheckboxDefaultProps;
var createInputCheckbox = function (props) {
  return React.createElement(exports.InputCheckbox, __assign({}, props));
};
exports.createInputCheckbox = createInputCheckbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;